export function formatTimestamp(timestamp) {
    if (!timestamp) return "";
    const [, timePart] = timestamp.split("T");
    const [hour, minute] = timePart.split(":").map(Number);
    const pad = (n) => n.toString().padStart(2, "0");
    return `${pad(hour)}:${pad(minute)}`;
}
